module.exports = __webpack_public_path__ + "static/img/20211230170257.eb15576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/20211230170257.png
// module id = LqFs
// module chunks = 0